import React from "react";

import TableCommon from "components/common/dynamicTable/DynamicTable";

import "pages/branches/branches.scss";
import { useTranslation } from "react-i18next";

const Payment = () => {
  const { t } = useTranslation();
  const heading = [
    t("branch"),
    t("amount-due"),
    t("date-of-issue"),
    t("due-date"),
    t("invoice-nr"),
    "",
  ];
  const body = [
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
    {
      values: ["281.000€", "19/09/2022", "26/09/2022", "VDS-092022-56382"],
    },
  ];
  return (
    <div>
      <TableCommon heading={heading} body={body} name="payment" />
    </div>
  );
};

export default Payment;
